<template>
    <crud-facecade
     ref="olist"
        :url="url"
        :columns="columnList"
        :tableHeight="tableHeight"
        :buttons="[]"
        v-wechat-title="title"
        :addButton="{ enabled: true, permission: 'dic_event:create' }"
        :deleteButton="{ enabled: false, permission: 'default' }"
        :updateButton="{ enabled: false, permission: 'dic_event:modify' }"
    >
    <template #filter>
        <el-col :span="4" class="align-center">
            是否启用:
        </el-col>
        <el-col :span="4">
            <item-input type="select"  v-model="isenabled" :options="is_enabled" clearable placeholder="事件状态"></item-input>
        </el-col>
        <el-col :span="6" class="align-center">
            是否显示自定义事件:
        </el-col>
        <el-col :span="4">
            <item-input type="select"  v-model="isshowzdy" :options="enum_bool" clearable placeholder="是否显示自定义事件"></item-input>
        </el-col>
    </template>
    </crud-facecade>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: `AnaesthesiaEvent`,
    data() {
        return {
            title: `麻醉事件`,
            eventCategory: [],
            isenabled: false,
            isshowzdy: false,
            url: {
                baseURL: `/api/AcisSystem/Event`,
                get: paras => {
                    return new Promise(resolve => {
                        this.ReloadData().then(data => {
                            resolve(data)
                        })
                    })
                },
                put: row => {
                    return this.saveOne(row, `put`)
                }
            }
        }
    },
    created() {
        this.loadEventCategory()
    },
    computed: {
        ...mapGetters([`sys_enums`, `is_enabled`, `enum_bool`, `menu_icons`, `img_icons`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `ID`,
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                {
                    type: `number`,
                    prop: `display_order`,
                    label: `排序`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    readonly: function(that, { row }) {
                        return row.id <= 0
                    },
                    sortable: true,
                    isDisplayOrder: true
                },
                {
                    type: `select`,
                    prop: `dic_event_category_id`,
                    label: `类别`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    sortable: true,
                    isCreatable: true,
                    options: this.eventCategory,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `code`,
                    label: `编码`,
                    isListable: true,
                    isExpand: false,
                    sortable: true,
                    isEditable: true,
                    isCreatable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `名称`,
                    isListable: true,
                    isExpand: false,
                    sortable: true,
                    isEditable: true,
                    isCreatable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `alias`,
                    label: `别称`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true
                },
                {
                    type: `imgicon`,
                    prop: `img_name`,
                    label: `图片`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    options: this.img_icons
                },
                {
                    type: `colorpicker`,
                    prop: `img_color`,
                    label: `颜色`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true
                },
                {
                    type: `select`,
                    prop: `is_unique`,
                    label: `是否唯一`,
                    width: `160`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: `enum_bool`,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    default: false
                },
                {
                    type: `select`,
                    prop: `is_read_only`,
                    label: `是否只读`,
                    width: `160`,
                    isListable: false,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: `enum_bool`,
                    default: false
                },
                {
                    type: `select`,
                    prop: `can_be_deleted`,
                    label: `是否可以删除`,
                    width: `160`,
                    isListable: false,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    options: `enum_bool`,
                    default: true
                },
                {
                    type: `rbool`,
                    prop: `is_deleted`,
                    label: `状态`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    sortable: true,
                    isCreatable: true,
                    readonly: false,
                    options: `is_enabled`,
                    default: false
                },
                {
                    type: `textarea`,
                    prop: `default_remark`,
                    label: `默认备注(※分隔可以选择)`,
                    colspan: 24,
                    isListable: false,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `60`,
                    fixed: `right`,
                    readonly: false,
                    isListable: true,
                    options: [
                        {
                            class: `is-plain`,
                            label: `编辑`,
                            type: `primary`,
                            emit: `LoadingUpdateView`,
                            permission: `dic_event:modify` // user:assignRole
                        }
                    ]
                }
            ]
        }
    },
    methods: {
        ReloadData() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/Event/GetShowZdy?isshowzdy=${this.isshowzdy}`)
                req.then(data => {
                    let r = data
                    if (that.isenabled !== `` && that.isenabled !== null) {
                        r = _.filter(r, function(i) {
                            return i.is_deleted == that.isenabled
                        })
                    }
                    resolve(r)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadEventCategory() {
            let req = this.myaxios.get(`/api/AcisSystem/EventCategory/Get`)
            req.then(data => {
                this.eventCategory = _.map(data, d => {
                    return { value: d.id, label: d.name, jianpin: d.abbr }
                })
            }).catch(e => {
                console.log(e)
            })
        },
        saveOne(row, type) {
            let data = { ...row }

            return new Promise((resolve, reject) => {
                this.myaxios
                    .get(`api/AcisSystem/Event/ValidEventIsUsed?id=${data.id}`)
                    .then(d => {
                        if (d) {
                            this.$alert(d, `提醒`, {
                                dangerouslyUseHTMLString: true,
                                type: `warning`
                            }).then(d => {
                                let req = this.myaxios[type](`/api/AcisSystem/Event/Put`, data)
                                req.then(res => {
                                    resolve(res)
                                }).catch(e => reject(e))
                            })
                        } else {
                            let req = this.myaxios[type](`/api/AcisSystem/Event/Put`, data)
                            req.then(res => {
                                resolve(res)
                            }).catch(e => reject(e))
                        }
                    })
                    .catch()
            })
        }
    },
    watch: {
        isenabled: function() {
            this.$refs[`olist`].ReloadListData()
        },
        isshowzdy: function() {
            this.$refs[`olist`].ReloadListData()
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/AnaesthesiaEvent/Index.vue